'use client';

import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { parseNowrap } from '@/lib/utils/utils';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

export default function PhysicalInfo() {
    const { t } = useTranslation('physical-info');
    return (
        <section
            className="relative z-10 flex w-full flex-col items-center justify-center overflow-hidden bg-black text-white"
            style={{ height: 'var(--homepage-vh, 100svh)' }}
        >
            {/* Background Image */}
            <div
                className="absolute inset-0 z-0 h-full w-full"
                style={{
                    maskImage:
                        'linear-gradient(to bottom, transparent, #171D2C 20%, #171D2C 80%, transparent)',
                    WebkitMaskImage:
                        'linear-gradient(to bottom, transparent, #171D2C 20%, #171D2C 80%, transparent)',
                }}
            >
                <Image
                    src={getStaticAssetUrl('/home/bg-physical-info.webp')}
                    alt="Physical Info Background"
                    fill
                    className="object-cover"
                    priority
                />
            </div>

            {/* Centered Content */}
            <div className="tablet:items-center tablet:gap-[24px] j-h4 tablet:j-h2 tablet:max-w-[87.5vw] desktop:max-w-[1160px] relative z-10 flex w-[87.5vw] max-w-[480px] flex-col items-start justify-center gap-[16px]">
                <p className="tablet:text-center whitespace-pre-wrap text-start">
                    {t('title.part1')}
                </p>

                <p className="tablet:text-center whitespace-pre-wrap bg-[linear-gradient(90deg,#8F7EFF_0%,#FFB59E_100%)] bg-clip-text text-start text-transparent drop-shadow-sm">
                    {parseNowrap(t('title.part2'))}
                </p>
            </div>
        </section>
    );
}
